import React, { Component } from 'react';

class SpineMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Configuração de Espinhas </h2>
                <p>
                    Nesta página pode configurar a espinha dos percursos de cada linha.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Incluir ou retirar percursos e paragens da espinha</li>
                    <li>Alterar a prioridade e a descrição dos percursos</li>
                    <li>Mostrar a descrição das paragens fora da espinha</li>
                    <li>Marcar terminais complementares</li>
                </ul>
                <h3>Legenda</h3>
                <ul className="bulleted-list">
                    <li>Paragem a cinzento: fora da espinha</li>
                </ul>
            </div>
        );
    }
}
export default SpineMetadata;
